import React from 'react';
import { List, Image, Grid } from 'semantic-ui-react';
import { books } from '../../data';
import _ from 'lodash';
import { Book } from '../../utility/interfaces';

const getSlicedBooks = (allBooks: Book[]): Book[][] => {
    if (allBooks.length % 2 !== 0) {
        allBooks.pop();
    }
    return _.chunk(allBooks, allBooks.length / 2);
};

export const Books = () => {
    const bookGroups = getSlicedBooks(books);
    return (
        <Grid columns={2}>
            <Grid.Row>
                {bookGroups.map((bookGroup) => (
                    <Grid.Column>
                        <List selection verticalAlign="middle">
                            {bookGroup.map((book) => (
                                <List.Item href={book.linkUrl}>
                                    <Image avatar src={book.image} />
                                    <List.Content>
                                        <List.Header>{book.title}</List.Header>
                                    </List.Content>
                                </List.Item>
                            ))}
                        </List>
                    </Grid.Column>
                ))}
            </Grid.Row>
        </Grid>
    );
};
